import { ThemeProperties } from '../../core';

export interface ActionCardTheme {
	baseBorderRadius: string;
	baseBorderColor: string;
	baseBoxShadow: string;
	baseMinHeight: string;
	baseFocusRingColor: string;

	hoverBoxShadow: string;

	iconHorizontalPadding: string;
	iconVerticalPadding: string;
	iconBackground: string;
	iconSize: string;
	iconColor: string;

	contentPadding: string;
	contentGap: string;

	titleFont: string;
	titleFontColor: string;

	metaFont: string;
	metaFontColor: string;

	arrowPadding: string;
	arrowColor: string;

	chunkyMinHeight: string;
	chunkyIconHorizontalPadding: string;
	chunkyIconVerticalPadding: string;
	chunkyContentPadding: string;
	chunkyContentGap: string;
	chunkyTitleFont: string;
	chunkyMetaFont: string;
}
export const theme = new ThemeProperties('actionCard');
